import axios from "axios";
import { apiEndpoint } from '@iso/lib/helpers/endpoint';
import { authHeader } from '@iso/lib/helpers/authHeader';
import qs from 'qs';

export const divisionService = {
  getList,
  getListForProperty,
  getById,
  storeOrUpdate,
  destroy
};

/**
 * Get all divisions for a corporate group
 */
function getList(corporateGroupId, includeInactive = false) {
  const queryString = qs.stringify({
    corporate_group_id: corporateGroupId,
    include_inactive: includeInactive
  }, { addQueryPrefix: true });

  return axios
    .get(
      `${apiEndpoint.divisions}${queryString}`,
      {
        headers: authHeader(),
      }
    ).then(res => {
      if (res && res.status === 200 && res.data.code === '0000') {
        return res.data;
      }
    });
}

/**
 * Get the divisions a property can use: its corporate group's shared divisions,
 * or its own when it has no group. Each carries this property's `site` row
 * (contact person + hub) or null.
 */
function getListForProperty(propertyId, includeInactive = false) {
  const queryString = qs.stringify({
    property_id: propertyId,
    include_inactive: includeInactive
  }, { addQueryPrefix: true });

  return axios
    .get(
      `${apiEndpoint.divisions}${queryString}`,
      {
        headers: authHeader(),
      }
    ).then(res => {
      if (res && res.status === 200 && res.data.code === '0000') {
        return res.data;
      }
    });
}

/**
 * Get single division by ID
 */
function getById(id) {
  return axios
    .get(
      `${apiEndpoint.divisions}/${id}`,
      {
        headers: authHeader(),
      }
    ).then(res => {
      if (res && res.status === 200 && res.data.code === '0000') {
        return res.data;
      }
    });
}

/**
 * Create or update a division
 */
function storeOrUpdate(data, id = null) {
  return (id ? (
    axios
      .put(
        `${apiEndpoint.divisions}/${id}`,
        data,
        {
          headers: authHeader(),
        }
      )
  ) : (
    axios
      .post(
        `${apiEndpoint.divisions}`,
        data,
        {
          headers: authHeader()
        }
      )
  )).then(res => {
    if (res && res.status === 200) {
      return res.data;
    }
    return {};
  });
}

/**
 * Delete a division
 */
// propertyId: deleting from that property's Divisions tab — its own site row
// doesn't block the delete, only other properties using the division do.
function destroy(id, propertyId = null) {
  return axios
    .delete(
      `${apiEndpoint.divisions}/${id}${propertyId ? `?property_id=${encodeURIComponent(propertyId)}` : ''}`,
      {
        headers: authHeader()
      }
    ).then(res => {
      if (res && res.status === 200) {
        return res.data;
      }
    });
}
